<script>
  // Alpaca disclosure documents - required to be displayed
  const alpacaDisclosures = [
    { name: "Use & Risk Disclosure", url: "https://files.alpaca.markets/disclosures/library/UseAndRisk.pdf" },
    { name: "Terms & Conditions", url: "https://files.alpaca.markets/disclosures/library/TermsAndConditions.pdf" },
    { name: "Privacy Notice", url: "https://files.alpaca.markets/disclosures/library/PrivacyNotice.pdf" },
    { name: "PFOF Disclosure", url: "https://files.alpaca.markets/disclosures/library/PFOF.pdf" },
    { name: "Margin Disclosure", url: "https://files.alpaca.markets/disclosures/library/MarginDiscStmt.pdf" },
    { name: "Extended Hours Risk", url: "https://files.alpaca.markets/disclosures/library/ExtHrsRisk.pdf" },
    { name: "BCP Summary", url: "https://files.alpaca.markets/disclosures/library/BCPSummary.pdf" },
    { name: "Form CRS", url: "https://files.alpaca.markets/disclosures/library/FormCRS.pdf" },
  ];
</script>

<footer class="border-t border-line bg-surface mt-12">
  <div class="max-w-7xl mx-auto px-4 md:px-8 py-8">
    <!-- Regulatory disclosures -->
    <p class="text-xs font-semibold uppercase tracking-wider text-ink-tertiary mb-3">
      Brokerage disclosures
    </p>
    <ul class="flex flex-wrap gap-x-5 gap-y-1.5 mb-6">
      {#each alpacaDisclosures as disclosure}
        <li>
          <a
            href={disclosure.url}
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-ink-secondary hover:text-ink underline underline-offset-2 decoration-line hover:decoration-ink-tertiary"
          >
            {disclosure.name}
          </a>
        </li>
      {/each}
    </ul>

    <p class="text-xs text-ink-tertiary leading-relaxed max-w-3xl">
      Securities brokerage services are provided by Alpaca Securities LLC ("Alpaca Securities"),
      member <a href="https://www.finra.org" target="_blank" rel="noopener" class="underline underline-offset-2 hover:text-ink-secondary">FINRA</a> /
      <a href="https://www.sipc.org" target="_blank" rel="noopener" class="underline underline-offset-2 hover:text-ink-secondary">SIPC</a>.
      Alpaca Securities is a wholly-owned subsidiary of AlpacaDB, Inc.
      Investing in securities involves risk and you may lose money. Past performance
      does not guarantee future results. Please review all disclosures before opening an account.
    </p>

    <div class="flex flex-wrap items-center justify-between gap-4 border-t border-line mt-6 pt-6">
      <p class="text-xs text-ink-tertiary">
        © {new Date().getFullYear()} <a href="/" class="font-medium text-ink-secondary hover:text-ink">Moira Finance</a>. All rights reserved.
      </p>
      <ul class="flex flex-wrap items-center gap-5">
        <li>
          <a href="/terms" class="text-xs text-ink-secondary hover:text-ink">Terms of Service</a>
        </li>
        <li>
          <a href="/privacy" class="text-xs text-ink-secondary hover:text-ink">Privacy Policy</a>
        </li>
        <li>
          <a href="https://alpaca.markets/disclosures" target="_blank" rel="noopener" class="text-xs text-ink-secondary hover:text-ink">
            All Disclosures
          </a>
        </li>
        <li>
          <a href="mailto:support@moirafinance.com" class="text-xs text-ink-secondary hover:text-ink">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</footer>
